import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.config.errorHandler = (err) => {
  if (err.message && err.message.includes("reading 'title'")) {
    // 只吞这个错误
    return;
  }
  console.error(err);
};

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
